import { render, staticRenderFns } from "./validCode.vue?vue&type=template&id=5d9564ae&scoped=true&"
import script from "./validCode.vue?vue&type=script&lang=js&"
export * from "./validCode.vue?vue&type=script&lang=js&"
import style0 from "./validCode.vue?vue&type=style&index=0&id=5d9564ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9564ae",
  null
  
)

export default component.exports